
import * as actionTypes from './actionType';

export const selectProject = (projectID) => { return {type: actionTypes.SET_PROJECT, 'currentProjectID': projectID} }
export const doProjectUpdate = (project) => { return {type: actionTypes.DO_PROJECT_UPDATE, 'performProjectUpdate': project} }
export const endProjectUpdate = () => { return {type: actionTypes.END_PROJECT_UPDATE, 'performProjectUpdate': false} }
